// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"Suggestions_sectionContainer__pbYAV","loaderContainer":"Suggestions_loaderContainer___ItOr","emptyContainer":"Suggestions_emptyContainer__9sH4o"};